import { useFixturesFromQuery } from './fixtures'

/** Preserve ?fixtures=1 across in-app navigation during visual review. */
export function useAppPath() {
  const fixtures = useFixturesFromQuery()
  return (path: string) => {
    if (!fixtures) return path
    const [base, hash = ''] = path.split('#')
    const joiner = base.includes('?') ? '&' : '?'
    return `${base}${joiner}fixtures=1${hash ? `#${hash}` : ''}`
  }
}
